import './horizontal-accordion.component.js';